export const ipcTableOfClusterDetail = {
    multiSort: '※Shiftを押しながら各項目をクリックすると複数項目で並べ替えできます。',
    searchAll: 'すべて検索',
    userInputPlaceholder: 'キーワードを入力してください',
    column1: 'IPCコード',
    column2: 'IPCサブクラス',
    column3: 'IPCメイングループ',
    column4: 'IPCサブグループ',
    column5: '因子負荷量',
    column6: '特許出願数',

    csvColumn1: 'IPCコード',
    csvColumn2: 'IPCサブクラス',
    csvColumn3: 'IPCメイングループ',
    csvColumn4: 'IPCサブグループ',
    csvColumn5: '因子負荷量',
    csvColumn6: '特許出願数'
}
